/*
*
*	AUTHOR : Jay Brummels
*   DATE : 4/2/10
*   VERSION : 1.4
*   USE: Appends a pager to the page with a previous and next button that scroll through the pages to the max value passed in.
*            The longer you hold the button down the faster it goes through the pages
*             When Clicked the links fire a pageChanged event and passes back the page.
*/
(function ($, obj) {
	$.extend(obj, {
		pagerEnabled: function (enabled, pagerInstance) {
			// Todo add pagerInstance property
			$('div.pager').parent().pagerSetEnabled(enabled);
		}
	});

	$.fn.pagingBar = function (options) {
		options = $.extend({
			actionLabel: 'Page',
			recordType: 'records',
			firstLast: true,
			total: 0,
			current: null,
			instance: null,
			history: false
		}, options);

		return this.each(function () {
			var first = $('<div class="first button" title="Skip to first ' + options.recordType.substr(0, options.recordType.length - 1) + '">&laquo;|</div>')
							.click(function (evt) {
								var $pager = $(this).closest('.pager').parent();
								if ($pager.data('current') != 1)
									$pager.pagerPage(1);
								return false;
							});
							var last = $('<div class="last button" title="Skip to last ' + options.recordType.substr(0, options.recordType.length - 1) + '">|&raquo;</div>')
							.click(function (evt) {
								var $pager = $(this).closest('.pager').parent();
								var max = $pager.pagerMax();
								if ($pager.data('current') != max)
									$pager.pagerPage(max);
								return false;
							});
			$(this)
				.If(options.history)
					.addClass('pagerHistoryEnabled')
					.bind('pageChanged', function (evt, page) {
						log('pageChanged, adding history: ' + page);
						Origin.addHistory('page=' + page);
					})
				.end()
				.If(options.instance != null)
					.data('pagerInstance', options.instance)
				.end()
				.pager(options.total, options.current)
				.append('<div class="status">&nbsp;&nbsp;' + options.actionLabel + ' <span class="data-current-page">' + (options.current ? options.current : '-') + '</span>&nbsp;of '
						+ '<span class="data-total-page-count">' + (options.total == 0 ? '-' : options.total) + '</span></div>')
				.find('> div.pager')
					.find('> span')
						.remove()
					.end()
					.find('div.button')
						.attr('title', 'Hold down to quickly scroll through ' + options.recordType)
					.end()
					.If(options.firstLast)
						.prepend(first)
						.append(last);

			var _this = this;
			Origin.onData('totalPageCount', function (totalPageCount, instance) {
				var pi = $(_this).data('pagerInstance');
				if (!pi || (pi && instance && pi == instance)) {
					$(_this).pagerMax(totalPageCount);
				}
			});
			if (options.history) {
				Origin.onHistory(function (data) {
					if (data.params.page) {
						var page = $(_this).pagerPage();
						if (page != data.params.page) {
							$(_this).pagerPage(data.params.page);
						}
					}
				});
			}
		});
	};

	$.fn.pager = function (max, current) {
		var xl;
		return this.each(function () {
			var $self = $(this);
			$self
				.data('max', 1)
				.data('current', 1)
				.bind('tryPageChanged', function (evt, page) {
					if ($self.data('current') != page) {
						$self
							.data('current', page)
							.trigger('pageChanged', [page]);
					}
				})
				.append('<div class="pager"><div class="prev button">&laquo;</div><div class="page"></div><div class="next button">&raquo;</div><span></span></div>')
				.find('div.pager > div')
					.css({
						'float': 'left'
					})
				.end()
				.find('div.pager > div.page')
					.data('page', 1)
					.text(1)
					.css({
						'width': (parseInt($self.pagerMax().toString().length) * 10) + 'px',
						'text-align': 'center',
						'margin': '0 .5em'
					})
					.bind('mouseenter.pager mouseleave.pager', function (evt) {
						$(this)[evt.type == 'mouseenter' ? 'addClass' : 'removeClass']('hover');
					})
					.bind('click.pager', function (evt) {
						var $page = $('div.page', $self);
						if (!$(this).hasClass('disabled')) { //don't run if its been disabled.
							$self.pagerSetEnabled(false); //disable the buttons
							var $page = $(this);
							var $input = $('<input type="text" class="text" />')
								.css({
									'width': (parseInt($self.pagerMax().toString().length) * 10) + 'px',
									'margin': '0 1em',
									'float': 'left'
								})
								.attr({
									'autocomplete': 'off',
									'maxlength': $self.pagerMax().toString().length
								})
								.hide();
							$page
								.after($input)
								.hide();
							$input
								.fadeIn('slow')
								.focus()
								.bind('blur.pager', function (evt) {
									$(this).remove();
									$page.removeClass('hover').fadeIn('slow');
									$self.pagerSetEnabled(true);
								})
								.bind('keydown.pager', function (evt) {
									switch (evt.keyCode) {
										case 9:  // tab
										case 13: // return
											evt.preventDefault();
											// check that values is between 1 and max and then set page and enable again, else add class error
											var value = $(this).val();
											if (parseInt(value, 10) == value && value >= 1 && value <= $self.data('max')) {
												$(this).remove();
												var current = $self.data('current');
												$self
													.pagerPage(value, current != value)
													.pagerSetEnabled(true);
												$page.removeClass('hover').fadeIn('slow');
											} else {
												$(this).addClass('error');
											}
											break;
										case 27: // escape key
											// remove input and show the page number, enable again
											$(this).remove();
											$page.removeClass('hover').fadeIn('slow');
											$self.pagerSetEnabled(true);
											break;
										default:
											if (evt.charCode) {  //if not a character don't allow it
												var character = String.fromCharCode(evt.charCode);
												if (character.match(/^[0-9]*$/) === null) {
													evt.preventDefault();  //if not a number don't allow it
												}
											}
											break;
									}
								});
						}
					})
				.end()
				.find('div.pager > span')
					.css({
						'clear': 'both'
					})
				.end()
				.find('div.pager > div.button')
					.bind('mouseenter.pager mouseleave.pager', function (evt) {
						$(this)[evt.type == 'mouseenter' ? 'addClass' : 'removeClass']('hover');
					})
					.bind('mousedown.pager', function (evt) {
						var $page = $('div.page', $self);
						if (!$(this).hasClass('disabled')) { //don't run if its been disabled.
							$(document).disableSelection();
							$(document).bind('mouseup.pager', function () {
								clearTimeout(xl);
								originTimer.start(function () {
									clearTimeout(xl);
									$self.trigger('tryPageChanged', [$page.data('page')]);
									$(document).unbind('mouseup.pager');
									$(document).enableSelection();
								}, 300);
							});
							var $button = $(this);
							var times = 1;
							var func = function () {
								var doTimer = false;
								if ($button.is('div.next')) {
									if ($page.data('page') < $self.data('max')) {
										$page.data('page', $page.data('page') + 1);
										doTimer = true;
									}
								} else {
									if ($page.data('page') > 1) {
										$page.data('page', $page.data('page') - 1);
										doTimer = true;
									}
								}
								times += 1;
								$page.text($page.data('page'));
								if (doTimer) {  //dont do if at max or 1
									xl = setTimeout(func, times < 10 ? 250 - (times * 10) : 50);
								}
							};
							func();
						}
					})
				.end()
			if (max) {
				$self.pagerMax(max);
			}
			if (current) {
				$self.pagerPage(current, false);
			}
		});
	};

	// set whether or not the page is enabled.
	$.fn.pagerSetEnabled = function (enabled) {
		return this.each(function () {
			$(this).find('div.pager > div')[(enabled === false) ? 'addClass' : 'removeClass']('disabled');
		});
	};

	$.fn.pagerPage = function (page, triggerPageChangedFlag) {
		if (page === undefined) {//if page is not passed in return the actual page number
			return this.eq(0).find('div.pager > div.page').data('page');
		} else { //set the actual page number
			page = parseInt(page, 10) || 1; //if page is not a number set it to 1 
			return this.each(function () {
				page = page > $(this).pagerMax() ? $(this).pagerMax() : page; //if it greater than the max then set to max
				page = page < 1 ? 1 : page;  //if page is less than one then set to 1

				$(this)
					.data('current', page)
					.find('div.pager > div.page')
					.data('page', page)
					.css({
						'width': (parseInt(page.toString().length) * 10) + 'px'
					})
					.text(page);
				if (triggerPageChangedFlag !== false) {
					$(this).trigger('pageChanged', [page]);
				}
			});
		}
	};

	$.fn.pagerMax = function (max) {
		if (max === undefined) {//if page is not passed in return the actual page number
			return this.eq(0).data('max');
		} else { //set the actual page number
			return this.each(function () {
				var $self = $(this);
				max = parseInt(max, 10) || $(this).data('max'); //if max is not a number set it to old max 
				max = max < 1 ? 1 : max;  //if max is less than one then set to 1

				// Set the width based on the text
				var pagerPage = $self.pagerPage();
				var pagerText = pagerPage !== undefined && pagerPage !== null ? pagerPage : max;
				var width = (parseInt(pagerText.toString().length) * 10) + 'px';

				$self
					.removeClass('pagerHidden')
					.data('max', max) //set the data
					.find('div.pager > div.page')  // make sure the width stays consitent up to the max
						.css({
							'width': ''
						})
						.text(max)
						.css({
							'width': width
						})
						.text($self.pagerPage());

				if (max == 1) {
					$self.addClass('pagerHidden');
				}
			});
		}
	};

	$.fn.pagerUnbind = function () {
		return this.each(function () {
			$('div.pager *', $(this)).unbind('.pager');
		});
	};

	$.fn.pagerDestroy = function () {
		return this.each(function () {
			$(this).find('div.pager').remove();
		});
	};
})(jQuery, Origin);

